import Link from 'next/link'
import { FC } from 'react'

import { cn } from '@/app/utils'
import { formatRuble } from '@/utils/number'

import { SidebarNavItemProps } from './Sidebar.types'

type Props = SidebarNavItemProps & {
  isActiveRoute: boolean
  tooltipProps: Record<string, unknown>
}

const SidebarNavItemActivator: FC<Props> = ({
  href,
  icon,
  activeIcon,
  name,
  count,
  className,
  onClick,
  isActive,
  showDot,
  isSidebarExpanded,
  isActiveRoute,
  tooltipProps
}) => {
  const baseClassName = cn(
    'group relative flex h-44 w-full items-center gap-12 rounded-8 p-10 transition-colors',
    (isActiveRoute || (isActive && !isSidebarExpanded)) && 'bg-grey-90',
    !isSidebarExpanded && 'w-44'
  )

  const resolvedIcon = isActiveRoute ? activeIcon ?? icon : icon

  const content = (
    <>
      <div
        className={cn(
          'relative h-24 w-24 text-white',
          !isActiveRoute && 'group-hover:text-white/50'
        )}
      >
        <div className="h-full w-24">{resolvedIcon}</div>
        {!isSidebarExpanded && showDot && (
          <div className="absolute -right-5 -top-5 flex h-8 w-8 rounded-full bg-bronze-40 font-bold" />
        )}
      </div>

      <div
        className={cn(
          'hidden',
          isSidebarExpanded && 'flex items-center gap-12'
        )}
      >
        <p
          className={cn(
            'font-pro !text-18 xs:!text-16',
            'text-white',
            !isActiveRoute && 'group-hover:text-white/50',

            className
          )}
        >
          {name}
        </p>

        {count && count > 0 ? (
          <span
            className={cn(
              'flex h-24 items-center justify-center',
              'rounded-full bg-bronze-40 font-bold !text-white text-12',
              'px-8'
            )}
          >
            {formatRuble(Math.floor(count))}
          </span>
        ) : null}
      </div>
    </>
  )

  if (href) {
    return (
      <Link
        aria-label={`Перейти в раздел ${name}`}
        className={baseClassName}
        onClick={onClick}
        href={href}
        {...tooltipProps}
      >
        {content}
      </Link>
    )
  }

  return (
    <button
      aria-label={name}
      type="button"
      className={baseClassName}
      onClick={onClick}
      {...tooltipProps}
    >
      {content}
    </button>
  )
}

export { SidebarNavItemActivator }
